import localForage from "localforage";

export async function getColorMode() {
  const params = new URLSearchParams(window.location.search);
  const colorModeFromCache = await localForage.getItem("ui_colorscheme");

  const colorMode =
    params.get("theme") || params.get("mode") || colorModeFromCache || "light";

  return colorMode;
}

export function setCurrentTheme(modeName = "light") {
  const html = document.querySelector("html");
  html?.setAttribute("data-theme", modeName);
}

export async function setupTheme() {
  let mode = await getColorMode();

  setCurrentTheme(mode);

  if (mode === "contrast") {
    mode = "light";
  }
}
